import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";

type Props = {
  open?: any;
  isCloseModal?: any;
  item?: any;
};

const ContactModal: React.FC<Props> = ({ open, isCloseModal, item }: Props) => {
  const closeDepModal = (isOpen: boolean) => {
    isCloseModal();
  };

  return (
    <Modal
      title={`Контакты поставщика`}
      open={open}
      onCancel={() => closeDepModal(false)}
      footer={[
        <Button key="cancel" onClick={() => closeDepModal(false)}>
          Отмена
        </Button>,
      ]}
    >
      <p>Почта</p>
      <a href="mailto:mail@mail.ru">mail@mail.ru</a>
      <p>Телефон</p>
      <a href="tel:+79999999999">+7-999-999-99-99</a>
    </Modal>
  );
};

export default ContactModal;
